<template>
    <Layout>
        <PageHeader :title="$t('module.configuration')" :items="breadcrumbs" />
        <div class="card">
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-lg-4 mb-2 mb-lg-0"><b-input-group><b-form-input v-model.trim="key"
                                :placeholder="$t('label.searchConfigurationKey')"
                                @keyup.enter="applyFilter" /><b-input-group-append><b-button variant="info"
                                    @click="applyFilter"><i
                                        class="mdi mdi-magnify"></i></b-button></b-input-group-append></b-input-group>
                    </div>
                    <div class="col-lg-3"><b-form-select v-model="activeFilter" :options="statusOptions"
                            @change="applyFilter" /></div>
                </div>
                <div v-if="!status.list" class="text-center p-5"><b-spinner variant="info" /></div>
                <template v-else>
                    <b-table :items="rows" :fields="fields" show-empty responsive no-local-sorting
                        @sort-changed="changeSort">
                        <template #cell(values)="{ item }">
                            <div v-for="value in item.values" :key="value.uuid"><code>{{ value.value }}</code></div>
                            <span v-if="!item.values.length">-</span>
                        </template>
                        <template #cell(isActive)="{ item }">
                            <b-form-checkbox :checked="item.isActive" switch :disabled="!status.save"
                                @change="changeStatus(item, $event)">
                                {{ item.isActive ? $t('label.active') : $t('label.inactive') }}
                            </b-form-checkbox>
                        </template>
                        <template #cell(actions)="{ item }">
                            <a href="javascript:void(0)" class="text-info"
                                :title="$t('label.updateX', [$t('module.configuration')])" @click="open(item)"><i
                                    class="mdi mdi-pencil-outline font-size-18"></i></a></template>
                    </b-table>
                    <div v-if="pagination.total" class="d-flex justify-content-between align-items-center mt-3"><small
                            class="text-muted">{{
                                $tc('label.results', pagination.total, [pagination.total]) }}</small><b-pagination
                            v-model="currentPage" :total-rows="pagination.total" :per-page="criteria.pageSize"
                            class="mb-0" @change="go" /></div>
                </template>
            </div>
        </div>
        <b-modal id="configuration-form" :title="$t('label.updateX', [$t('module.configuration')])" size="lg"
            hide-footer hide-header-close centered @hidden="close">
            <ConfigurationForm v-if="formVisible" :configuration-u-u-i-d="selectedUUID" :search-criteria="criteria"
                @done="close" />
        </b-modal>
    </Layout>
</template>

<script>
import { mapState } from 'vuex';
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header';
import i18n from '@/i18n';
import { configurationMethods } from '@/state/api';
import { CONFIGURATION_MODULE } from '@/state/api/configuration.state';
import ConfigurationForm from './form';

const defaults = () => ({ pageNumber: 1, pageSize: 15, key: '', isActive: '', sortBy: 'created_at', orderBy: 'desc' });
export default {
    name: 'ConfigurationListing', page: { title: i18n.t('module.configuration') }, components: { Layout, PageHeader, ConfigurationForm },
    data() {
        return {
            key: '',
            activeFilter: '',
            currentPage: 1,
            criteria: defaults(),
            formVisible: false,
            selectedUUID: '',
            breadcrumbs: [{text: i18n.t("module.system"), href: '/systems'},{ text: i18n.t('module.configuration'), active: true }],
            fields: [
                { key: 'key', label: i18n.t('label.key'), sortable: true },
                { key: 'keyValueHint', label: i18n.t('label.keyValueHint') },
                { key: 'isActive', label: i18n.t('label.status') },
                { key: 'actions', label: i18n.t('label.action') }]
        };
    },
    computed: {
        ...mapState(CONFIGURATION_MODULE, ['status']),
        rows() {
            return this.$store.state.api.configuration.list.data || [];
        },
        pagination() {
            return this.$store.state.api.configuration.list.pagination || {};
        },
        statusOptions() {
            return [
                { value: '', text: this.$t('label.all') },
                { value: 1, text: this.$t('label.active') },
                { value: 0, text: this.$t('label.inactive') }];
        },
    },
    created() {
        this.load();
    },
    methods: {
        ...configurationMethods,
        load() {
            return this.getAllConfiguration({ filter: this.criteria });
        },
        applyFilter() {
            this.currentPage = 1; this.criteria = { ...this.criteria, pageNumber: 1, key: this.key, isActive: this.activeFilter }; this.load();
        },
        go(pageNumber) {
            this.currentPage = pageNumber;
            this.criteria = {
                ...this.criteria,
                pageNumber
            };
            this.load();
        },
        changeSort({ sortBy, sortDesc }) {
            if (sortBy !== 'key') return;
            this.currentPage = 1;
            this.criteria = {
                ...this.criteria,
                pageNumber: 1,
                sortBy: 'key',
                orderBy: sortDesc ? 'desc' : 'asc'
            };
            this.load();
        },
        open(item) {
            this.selectedUUID = item.uuid;
            this.formVisible = true; this.$nextTick(() => this.$bvModal.show('configuration-form'));
        },
        close() {
            this.$bvModal.hide('configuration-form'); this.formVisible = false; this.selectedUUID = '';
        },
        async changeStatus(item, isActive) {
            const confirmed = await this.$bvModal.msgBoxConfirm(this.$t('label.confirmChangeStatusX', [isActive ? this.$t('label.activate') : this.$t('label.deactivate'), item.key]), { title: this.$t('label.confirmStatusChange'), centered: true });
            if (confirmed) {
                await this.updateConfigurationStatus({ uuid: item.uuid, isActive, filter: this.criteria });
            } else {
                await this.load();
            }
        },
    },
};
</script>
